





































































































































import { defineComponent, ref, onMounted, computed } from '@vue/composition-api'
import { mdiDotsVertical, mdiFilterVariantMinus, mdiEyeOutline, mdiBandage } from '@mdi/js'

// Shared
import PaginationSelect from '@shared/components/PaginationSelect.vue'
import PaginationFooter from '@shared/components/PaginationFooter.vue'

// Components
import SolicitudFiltro from '../components/SolicitudFiltro.vue'
import SolicitudVisualizarModal from '../components/SolicitudVisualizarModal.vue'
import SolicitudSubsanarModal from '../components/SolicitudSubsanarModal.vue'

import { IResponseElement, SolicitudFiltroModel, SolicitudInterface, Pagination } from '@/models'
import store from '@/store'
import useAppConfig from '@core/@app-config/useAppConfig'
import { formatISODate } from '@core/utils/filter'

export default defineComponent({
  // type inference enabled
  components: {
    PaginationSelect,
    PaginationFooter,
    SolicitudFiltro,
    SolicitudVisualizarModal,
    SolicitudSubsanarModal,
  },
  setup() {
    const isFilterPanelActive = ref(false)
    const mostrarVisualizarModal = ref(false)
    const mostrarSubsanarModal = ref(false)
    const filtro = ref(new SolicitudFiltroModel())
    const pagination = ref(new Pagination())

    const { isLoading } = useAppConfig()
    const filterDate = computed(() => (ISODate: string) => formatISODate(ISODate))

    onMounted(() => {
      obtenerSolicitudes(filtro.value)
    })

    const obtenerSolicitudes = async (filter: SolicitudFiltroModel) => {
      filtro.value = filter
      const params = { ...filtro.value, start: filtro.value.start - 1 }

      isLoading.value = true
      const { ok, response } = await store.dispatch('solicitud/obtenerSolicitudes', params)

      if (ok) {
        actualizarPaginacion(response)
      }

      isLoading.value = false
    }

    const actualizarPaginacion = (response: IResponseElement<SolicitudInterface>) => {
      pagination.value.setPagination(filtro.value.start, filtro.value.limit, response.totalCount)
      filtro.value.start = pagination.value.number
    }

    const visualizar = async (solicitud: SolicitudInterface) => {
      isLoading.value = true
      mostrarVisualizarModal.value = true
      const { ok } = await store.dispatch('solicitud/obtenerSolicitud', solicitud.solicitudId)

      if (!ok) {
        mostrarVisualizarModal.value = false
      }
      isLoading.value = false
    }

    const visualizarModalOnClose = (actualizar: boolean) => {
      mostrarVisualizarModal.value = false
      if (actualizar) {
        obtenerSolicitudes(filtro.value)
      }
    }

    const subsanar = async (solicitud: SolicitudInterface) => {
      store.commit('solicitud/cargarSolicitud', solicitud)
      mostrarSubsanarModal.value = true
    }

    const subsanarModalOnClose = (actualizar: boolean) => {
      store.commit('solicitud/limpiarSolicitud')
      mostrarSubsanarModal.value = false
      if (actualizar) {
        obtenerSolicitudes(filtro.value)
      }
    }

    return {
      filtro,
      isFilterPanelActive,
      isLoading,
      mostrarSubsanarModal,
      mostrarVisualizarModal,
      obtenerSolicitudes,
      subsanar,
      subsanarModalOnClose,
      pagination,
      filterDate,
      solicitudes: computed<SolicitudInterface[]>(() => store.getters['solicitud/solicitudes']),
      visualizar,
      visualizarModalOnClose,
      icons: {
        mdiDotsVertical,
        mdiFilterVariantMinus,
        mdiEyeOutline,
        mdiBandage,
      },
    }
  },
})
